import axios from "axios";
import { getCookie } from "../../../App";
import { domain } from "../../Links/Links";
import { useNavigate } from "react-router-dom";

export async function recoveryConfirmationRequest(
    value,
    navigate,
    setRequestStatus
) {
    setRequestStatus({
        loading: true,
        error: null,
    });

    try {
        const { data } = await axios.post(
            domain + "/password_recovery/",
            {
                value: value,
            },
            {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": getCookie("csrf_token"),
                },
            }
        );

        if (data.status) {
            setRequestStatus({
                loading: false,
                error: null,
            });
            sessionStorage.setItem(
            "passwordRecovery",
            JSON.stringify({
                otpId: data.id,
                email: data.email
            })
            );            
            navigate("/password_recovery_step2");
        } else {
            setRequestStatus({
                loading: false,
                error: data.error,
            });
        }
    } catch (error) {
        console.error(error);
        setRequestStatus({
            loading: false,
            error: error.response?.data?.error,
        });
    }
}



export async function verifyRecoveryCodeRequest(
    code,
    otpId,
    navigate,
    setRequestStatus
) {

    setRequestStatus({
        loading: true,
        error: null,
    });

    try {
        const { data } = await axios.post(
            domain + "/password_recovery_verify/",
            {
                otp_id: otpId,
                code: code,
            },
            {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": getCookie("csrf_token"),
                },
            }
        );

        if(data.status){
            setRequestStatus({
                loading:false,
                error:null
            });
            navigate("/password_recovery_step3");

        } else{
            setRequestStatus({
                loading:false,
                error:data.error
            });
        }

    } catch(error){
        setRequestStatus({
            loading:false,
            error:error.response?.data?.error || "Server error"
        });
    }

}



export async function resetPasswordRequest(
    password,
    otpId,
    navigate,
    setRequestStatus
){
    setRequestStatus({
        loading:true,
        error:null
    });

    try{
        const {data} = await axios.post(
            domain + "/password_recovery_reset/",
            {
                otp_id: otpId,
                password: password
            },
            {
                withCredentials:true,
                headers:{
                    "X-CSRFToken": getCookie("csrf_token")
                }
            }
        );

        if(data.status){
            sessionStorage.removeItem("passwordRecovery");

            setRequestStatus({
                loading:false,
                error:null
            });

            navigate("/signin");
        }else{
            setRequestStatus({
                loading:false,
                error:data.error
            });
        }

    }catch(error){

        setRequestStatus({
            loading:false,
            error:error.response?.data?.error || "Server error"
        });

    }

}